import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  flashcardLibraryService,
  type AddLibraryCardToDeckInput,
  type ReportLibraryCardInput,
} from '../api/flashcardLibraryService';

export function useFlashcardLibrary(bookId: string, secureContentChunkId: string | null) {
  const queryClient = useQueryClient();

  const { data: cards = [], isLoading, error, refetch } = useQuery({
    queryKey: ['flashcard-library', bookId, secureContentChunkId],
    queryFn: () => flashcardLibraryService.getByChapter(bookId, secureContentChunkId!),
    enabled: !!bookId && !!secureContentChunkId,
  });

  const addToDeck = useMutation({
    mutationFn: (input: AddLibraryCardToDeckInput) => flashcardLibraryService.addToDeck(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flashcard-library', bookId, secureContentChunkId] });
      queryClient.invalidateQueries({ queryKey: ['flashcards'] });
      queryClient.invalidateQueries({ queryKey: ['flashcard-decks'] });
    },
  });

  const report = useMutation({
    mutationFn: (input: ReportLibraryCardInput) => flashcardLibraryService.report(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flashcard-library', bookId, secureContentChunkId] });
    },
  });

  return {
    cards,
    isLoading,
    error,
    refetch,
    addToDeck: addToDeck.mutateAsync,
    report: report.mutateAsync,
    isAddingToDeck: addToDeck.isPending,
  };
}
